import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import {
    isEnabledForFrontierCopilotAudience,
    type FrontierFlightConfig,
} from './isEnabledForFrontierCopilotAudience';

const calendarAgentHelixFrontierFlights: FrontierFlightConfig = {
    publicFlight: 'cal-copilot-default-calendar-agent-helix-frontier-public',
    privateTapFlight: 'cal-copilot-default-calendar-agent-helix-frontier-private-tap',
    privateStagingFlight: 'cal-copilot-default-calendar-agent-helix-frontier-private-staging',
    privateInfluencerFlight: 'cal-copilot-default-calendar-agent-helix-frontier-private-influencer',
};

/**
 * Checks if the CalendarAgentHelix variant is enabled.
 *
 * Returns true if EITHER:
 * - The global `cal-copilot-default-calendar-agent-helix` flight is on (conventional rollout), OR
 * - The user is a licensed frontier user and the frontier flight for their type is enabled
 */
export function isCalendarAgentHelixEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        isGlobalFeatureEnabled('cal-copilot-default-calendar-agent-helix') ||
        isEnabledForFrontierCopilotAudience(mailboxInfo, calendarAgentHelixFrontierFlights)
    );
}
